import { useQuery } from '@tanstack/react-query';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '@/services/firebase';
import { converter } from '@/lib/firestore-converters';
import { reviews as seedReviews } from '@/data';
import type { Review } from '@/types';

const USE_SEED = import.meta.env.VITE_USE_SEED_DATA === 'true';

export function useReviews(productId: string) {
  return useQuery({
    queryKey: ['reviews', productId],
    queryFn: async (): Promise<Review[]> => {
      if (USE_SEED) return seedReviews.filter(r => r.productId === productId && r.moderated);
      const col = collection(db, 'reviews').withConverter(converter<Review>());
      const q = query(col, where('productId', '==', productId), where('moderated', '==', true));
      return (await getDocs(q)).docs.map(d => d.data());
    },
    enabled: Boolean(productId),
    staleTime: 5 * 60_000,
  });
}
